module.exports = __webpack_public_path__ + "static/img/memory1.3887b1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/memory1.jpg
// module id = qO9Z
// module chunks = 1